import { IStore } from "../types";
import { IUserList, IUser, IWorkout } from "./types";

const EMPTY_ARRAY: any[] = [];
const EMPTY_OBJECT: any = {};

export function getUser({ user }: IStore): IUser | undefined {
  return user ? user.user : EMPTY_OBJECT;
}

export function getUsers({ user }: IStore): IUserList[] {
  return user ? user.list : EMPTY_ARRAY;
}

export function getCurrentWorkout({ user }: IStore): IWorkout {
  return user ? user.workout : EMPTY_OBJECT;
}
